module.exports = {
      id: "blockquote-usage",
      viewBox: "0 0 43 36",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#blockquote",
      toString: function () {
        return this.url;
      }
    }